<template>
  <div class="Others23Charts">
    <div
      class="slectBox"
      :style="{
        top: `${$w_Ratio(-12 + getShowfontSizeBase(), $store)}px`,
      }"
    >
      <el-select v-model="vidoModel" placeholder="" @change="handleChange">
        <el-option v-for="item in vidoList" :key="item.code" :label="item.name" :value="item.code">
        </el-option>
      </el-select>
    </div>
    <div class="test-player-wrap">
      <iframe allowfullscreen="true" :src="flowSrc" frameborder="0" class="videosrc"> </iframe>
    </div>
  </div>
</template>

<script>
import { request } from '../../../common/request';
import { getVideoStreaming } from '../../../utils/tool';
export default {
  name: 'Others23Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      vidoModel: '',
      params: {},
      flowSrc: '',
      vidoList: [],
      // vidoList: [
      //   {
      //     name: '锦成·文庙街南客流统计1',
      //     code: 'a772d587318b40f193f0a72e4675f8c0',
      //   },
      //   {
      //     name: '丁集婚纱小镇1',
      //     code: '51d32ea229d1438382b0a21fb7645d88',
      //   },
      //   {
      //     name: '丁集婚纱小镇2',
      //     code: '7217e17d7c5842338d8b10dea5fd6729',
      //   },
      //   {
      //     name: '丁集婚纱小镇3',
      //     code: 'beac1603dbd644f9a52ec0e8b7271c37',
      //   },
      //   {
      //     name: '锦成·文庙街西客流统计',
      //     code: '112c3536c95f448dafee0435d29b2706',
      //   },
      //   {
      //     name: '锦成·文庙街东客流统计',
      //     code: '3d07b3551a80433b9a7f0fd821d7fc67',
      //   },
      //   {
      //     name: '锦成·文庙街北客流统计',
      //     code: '364f264bb6bd477391ef8c91a8890365',
      //   },
      //   {
      //     name: '锦成·文庙街南客流统计2',
      //     code: 'a8b19ae3630f4f36b9cec0051154364d',
      //   },
      //   {
      //     name: '锦成·文庙街南客流统计3',
      //     code: '6dd7a6ec58e54cd4a59e5a99c658a785',
      //   },
      //   {
      //     name: '紫荆花怡养小镇客流统计',
      //     code: 'fa9b7ea34d924f498ffcad51634bf675',
      //   },
      //   {
      //     name: '林水寨车道微卡口',
      //     code: '1756b804b2c64bea8dbfe43a3f7366a7',
      //   },
      //   {
      //     name: '林水寨景区游客采集',
      //     code: '5c16f7e3bd354c12b6270885d7a04af3',
      //   },
      //   {
      //     name: '林水寨景区游客采集云台',
      //     code: '96df0bbfd2784932a40722a097a429de',
      //   },
      //   {
      //     name: '六安瓜片茶文化体验中心微卡口',
      //     code: '464f9ca878554b40b458ca6e00c870fd',
      //   },
      //   {
      //     name: '六安瓜片茶文化体验中心客流统计',
      //     code: '9d31645fb5a54a57a21a381c28ac4495',
      //   },
      //   {
      //     name: '九公寨风景区卡口',
      //     code: 'ca116b85758a449ba58c94abce78c607',
      //   },
      //   {
      //     name: '横排头景区淠史航展览馆游客采集',
      //     code: 'c6cb3447d6604f9cb951f60460128647',
      //   },
      //   {
      //     name: '横排头景区淠史航展览馆游客采集云台',
      //     code: 'f2e7c750038d4c2ba132bd5149f9ef6f',
      //   },
      //   {
      //     name: '横排头景区慢直播',
      //     code: '9b106bda91874976a53a59dbf70b6a75',
      //   },
      //   {
      //     name: '横排头景区慢直播全景',
      //     code: '7a9a61c8b23a49d5bf2dfdd15ff371a2',
      //   },
      //   {
      //     name: '横排头景区北道路卡口',
      //     code: 'e0ba1e2ffae3425e8235734c473b9a3f',
      //   },
      //   {
      //     name: '横排头景区北道路卡口',
      //     code: '2c1ac597f701422197e8d70edc9d9f8e',
      //   },
      //   {
      //     name: '横排头景区门楼枪机',
      //     code: 'caae69c423854cba9455a63b4aaf7fbe',
      //   },
      //   {
      //     name: '横排头景区陈列馆游客采集',
      //     code: '31c26b4794294f0c948bdac3b62267f7',
      //   },
      //   {
      //     name: '横排头景区思源塘枪机',
      //     code: '0b3a63fc10c34c98a7e05d6765495345',
      //   },
      //   {
      //     name: '横排头景区思源桥枪机',
      //     code: '34d70f9fa9034008bd79e3bb6614d178',
      //   },
      //   {
      //     name: '裕安区游客集散中心北门客流统计',
      //     code: '1f3b61fcb93d47b789221e66fc7ad254',
      //   },
      //   {
      //     name: '裕安区游客集散中心南门客流统计',
      //     code: 'e15a30d32e5d4732adb097e7e48b6da1',
      //   },
      //   {
      //     name: '皋街西客流统计2',
      //     code: '16e180835dbb4df4b7f41a3e67fc3c7f',
      //   },
      //   {
      //     name: '皋街西客流统计1',
      //     code: '873ea36396e94a719476568d829dddd3',
      //   },
      //   {
      //     name: '皋街北客流统计',
      //     code: '039fdbcace934c9a97940a66fdf7abbe',
      //   },
      //   {
      //     name: '皋街东客流统计',
      //     code: '6705a695d82d49478e5081e301bc4354',
      //   },
      //   {
      //     name: '皋街慢直播细节',
      //     code: '98bc824893ae4d0f8d98de7846dac8ba',
      //   },
      //   {
      //     name: '皋街慢直播全景',
      //     code: '272a84a38c2a42d989494b604ef2a6e7',
      //   },
      //   {
      //     name: '独山革命旧址群经济合作社旧址客流统计',
      //     code: 'c181342fc7b54ac38f29b11072a88525',
      //   },
      //   {
      //     name: '独山革命旧址群游客采集1',
      //     code: '6f021455243147098e4958e55a229da3',
      //   },
      //   {
      //     name: '独山革命旧址革命法庭旧址客流统计',
      //     code: '1a24d74f57924bf9aea0addc28dd6108',
      //   },
      //   {
      //     name: '龙井沟景区慢直播细节相机',
      //     code: '3a12776edfdf4079b12e9678447d5045',
      //   },
      //   {
      //     name: '龙井沟景区慢直播全景相机',
      //     code: 'e2a6e4ebce4f44daaf6501161876694a',
      //   },
      //   {
      //     name: '横排头风景区南卡口',
      //     code: '4983bb76e3c04c6698d921a8586f3de9',
      //   },
      //   {
      //     name: '横排头景区停车场南门',
      //     code: '6836d41d4c1a4f238f778ff87f83815b',
      //   },
      //   {
      //     name: '横排头景区停车场西门',
      //     code: '7b077923a87948e18d0f4fe44dc9a39b',
      //   },
      //   {
      //     name: '横排头景区停车场',
      //     code: 'e9af45bb18984245adb8d4c471232888',
      //   },
      //   {
      //     name: '独山革命旧址群游客采集2',
      //     code: 'bfab9a2eaa6e4bc892a1739b88efe8e1',
      //   },
      //   {
      //     name: '独山革命旧址群六霍起义纪念塔枪机1',
      //     code: '997fbfa4419e425d8a0fbce5a8292a53',
      //   },
      //   {
      //     name: '独山革命旧址群六霍起义纪念塔枪机2',
      //     code: '4d5a82189904454fbb7af0a846157575',
      //   },
      //   {
      //     name: '独山革命旧址群六霍起义纪念塔枪机3',
      //     code: '600b073b881f412da069536389b4b4b9',
      //   },
      //   {
      //     name: '独山革命旧址群六霍起义纪念塔枪机4',
      //     code: '1c05a5ce79984d8a894a62fe5aa3cd45',
      //   },
      //   {
      //     name: '小龙生态园东门游客采集云台',
      //     code: 'f4af16623c944107a7afaab0163e72de',
      //   },
      //   {
      //     name: '小龙生态园东门游客采集',
      //     code: 'cfe7e4c3b3ed4e979208a6ef4e9850db',
      //   },
      //   {
      //     name: '小龙生态园西门游客采集云台',
      //     code: '45b4b440343d4ff8b2aa869e52e9dd64',
      //   },
      //   {
      //     name: '小龙生态园西门游客采集',
      //     code: '37d3acf32b2342278b29d73bdebe3305',
      //   },
      //   {
      //     name: '许继慎纪念园游客采集云台',
      //     code: '65c5fdc4f82347cca989496232a69cea',
      //   },
      //   {
      //     name: '许继慎纪念园游客采集',
      //     code: 'dfcf2b9a7f604bb19874cbbc621caef8',
      //   },
      //   {
      //     name: '樱花溪畔游客采集云台',
      //     code: 'fde22f2aea654dec80f04bf678071136',
      //   },
      //   {
      //     name: '樱花溪畔游客采集',
      //     code: 'c8156c0c05c64e3f8893b5cdb2050725',
      //   },
      //   {
      //     name: '龙井沟风景区卡口',
      //     code: '2d03eeb0f2024dcdaebb20b099bf0e07',
      //   },
      //   {
      //     name: '龙井沟景区游客采集',
      //     code: '5de93d627bed4d1b8bdf5f8ec0910d2a',
      //   },
      //   {
      //     name: '龙井沟景区游客采集云台',
      //     code: '2d1b58c1d37848008c709816902a62da',
      //   },
      // ],
      selectApi: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });

    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');

    this.vidoList = this.Configuration?.propertyData?.iframeConfiger?.value?.selectorData;
    if (this.vidoList && this.vidoList.length > 0) {
      this.vidoModel = this.vidoList[0].code;
    }
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  methods: {
    handleChange(selectedValue) {
      this.vidoModel = selectedValue;
      this.params = { deviceid: selectedValue };
      this.startApiIntervalTask();
    },
    getVideoStreaming(e) {
      return getVideoStreaming(e);
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      console.log('ParamData', ParamData);

      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];

      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      let iframe = {};

      if (this.Configuration.propertyData?.chartsColor?.value?.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }

      if (ParamData) {
        seriesList = ParamData.seriesList;
        source = ParamData.source;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (this.Configuration.propertyData?.iframeConfiger?.value?.selectorData) {
        this.vidoList = this.Configuration.propertyData.iframeConfiger.value.selectorData;
      }

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(grid);

      this.flowSrc = '';
      const iframeSrc = `${source[0].x}?src=${source[0].y}&width=100vw&height=100vh`;
      this.flowSrc = iframeSrc; // 赋值给 iframe 的 src
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        func();
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let params = ChartsData.apiData.apiPostParams || {};
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};

          eval(filter_text);

          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },

  Configuration: {
    componentTitle: '智能监控2.0',
    componentName: 'Others23Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others4Charts.png',
    id: '',
    style: {
      width: 250,
      height: 300,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    borderConfig: {
      propertyComponentName: 'ChartsBorderConfiger',
      value: {
        borderComponentName: 'Charts1Border',
      },
    },
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts0Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://m.cqlpmysblzh.com/gthmmc/index.php?m=amobiletour&c=dataMange&a=queryDataOfResource&pageNo=1&pageNum=999&directory_code=video',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.data',
            isUseFilter: true,
            apiFilter: `
          let seriesList = []
dataSet.seriesList = seriesList
dataSet.source = []
dataSet.source.push({
  s: "数据",
  x: 'http://114.98.87.76:30021/h5player/player.html',
  y: data,
})

            `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['地址'],
            source: [
              {
                s: '地址',
                y: 'https://tb-video.bdstatic.com/tieba-smallvideo-transcode-crf/116931661_eb38c191612950f32dae5f26ddcf0a95_22409283003c_0.mp4?vt=1&pt=3&ver=&cr=2&cd=0&sid=&ft=8&tbau=2024-10-13_ebccf71dc9862bbf72b6124df7fe7b59aac00c78e199c44cd833764012b15fc9&ptid=7637698958',
                x: 'url1',
              },
              {
                s: '地址',
                y: 'https://tb-video.bdstatic.com/tieba-smallvideo-transcode-crf/116931661_eb38c191612950f32dae5f26ddcf0a95_22409283003c_0.mp4?vt=1&pt=3&ver=&cr=2&cd=0&sid=&ft=8&tbau=2024-10-13_ebccf71dc9862bbf72b6124df7fe7b59aac00c78e199c44cd833764012b15fc9&ptid=7637698958',
                x: 'url2',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      iframeConfiger: {
        propertyComponentName: 'iframePulldownDataConfiger',
        value: {
          selectorData: [{ name: '龙井沟风景区卡口', code: '2d03eeb0f2024dcdaebb20b099bf0e07' }],
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Others23Charts {
  /* background-color: rgba(28, 35, 46, 0.6196078431); */
  /* border-radius: 10px; */
  width: 100%;
  height: 100%;
  /* padding: 20px 10px; */
  position: relative;
  .slectBox {
    position: relative;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #4ed6f6;

    span {
      line-height: 2;
      font-size: 14px;
      position: relative;
      left: 28px;
      top: 4px;
    }
  }
  .test-player-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    iframe {
      z-index: 1;
      width: 100%;
      height: 84%;
      position: relative;
      top: -12px;
    }
  }

  .result {
    height: 80%;
    padding: 10px;
    border-radius: 10px;
    margin-top: 10px;

    .videoList {
      /* padding: 6px 0 6px 12px; */

      // min-height: 30px;
      .video {
        &:hover {
          cursor: pointer;
        }

        display: flex;
        align-items: center;

        span {
          &:nth-child(2) {
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
  }
  :deep(.el-select) {
    position: relative;
    line-height: 30px;
    float: right;
  }

  :deep(.el-input__inner) {
    background: none;
    border: 1px solid #357494;
    color: #fff;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  .el-input__icon :deep(.el-input__icon) {
    height: 30px;
    line-height: 30px;
  }
  :deep(.el-input__suffix-inner) {
    top: -6px;
    position: relative;
  }
}

/* .active {
  background: #1bc4c9;
} */

// 空谷幽兰
.V1Style {
  border-radius: 10px;
  padding: 0;
  background: rgba(46, 46, 46, 0.38);

  .title {
    background: url('/img/styles/titleIcons/youlan_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 12%;
    position: absolute;
    margin-top: -12%;
    max-width: 300px;
    min-height: 20px;
  }

  .result {
    height: 80%;
    padding: 10px;
    border-radius: 10px;
    background: none !important;

    .active {
      background: #0a61a8;
    }
  }
}

// 只此青蓝
.V2Style {
  border-radius: 10px;
  padding: 0;
  background: rgba(46, 46, 46, 0.38);

  .title {
    background: url('/img/styles/titleIcons/cyan_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 5%;
    position: absolute;
    margin-top: -12%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    background: none !important;

    .active {
      background: #2c4c40;
    }
  }
}

// 蔚蓝时代
.V3Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/blue_title.png') no-repeat;
    width: 100%;
    color: #fff;
    height: 5%;
    position: absolute;
    margin-top: -12%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 2;
      font-size: 14px;
      position: relative;
      left: 28px;
      top: 4px;
    }
  }

  .result {
    background: none !important;

    .active {
      background: #0a61a8;
    }
  }
}

// 紫气东来
.V4Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/purple_title.png') no-repeat;
    height: 5%;
    width: 100%;
    color: #fff;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    background: none !important;

    .active {
      background: #682f9e;
    }
  }
}

// 绿野仙踪
.V5Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/green_title.png') no-repeat;
    height: 10%;
    color: #fff;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;
  }

  .result {
    .active {
      background: #9fe9a9a2;
    }
  }
}

// 青绿时代
.V6Style {
  border-radius: 10px;
  padding: 0;

  .title {
    height: 10%;
    color: #fff;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 4;
    }
  }

  .result {
    .active {
      background: #c2c194;
    }
  }
}

// 蓝色风暴
.V7Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    background: url('/img/styles/titleIcons/V7_title.png') no-repeat;
    height: 10%;
    color: #fff;
    width: 96%;
    text-align: center;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      top: 8px;
      left: 0;
    }
  }

  .result {
    .active {
      background: #0a61a8;
    }
  }
}

// 青云雅韵
.V8Style {
  border-radius: 10px;
  padding: 0;
  background: none;

  .title {
    height: 10%;
    color: #61748a;
    width: 100%;
    position: absolute;
    margin-top: -16%;
    max-width: 312px;
    min-height: 40px;

    span {
      line-height: 4;
    }
  }

  .result {
    background: #fff;

    .videoList .video span {
      color: #000000a2 !important;
    }

    .active {
      background: #000000a2;
    }
  }
}
</style>
